module.exports = __webpack_public_path__ + "static/media/minijakten_final_2013_small.1559fdd1.jpg";